import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Formik } from 'formik';
import { getArtisanPrivateInquiryAction } from '../../../../modules/inquiries/artisans/private/Actions';
import {
  inquiryByIdSelector,
  artisanPrivateInquiriesIsLoadingSelector,
} from '../../../../modules/inquiries/artisans/private/Selectors';
import {
  // getPendingPrivateInquiriesAction,
  // deleteSingleArtisanPrivateInquiryAction,
  // getSingleArtisanPrivateInquiryAction,
  // moderatePendingProposalAction,
  // updatePendingPrivateInquiryAction,
  getAllPendingProposalAction,
  getSinglePendingProposalAction,
  moderatePendingProposalAction,
  rejectPendingProposalAction
} from '../../../../modules/artisanModeration/privateProposals/Actions';
import {
  pendingArtisansPrivateInquiryIsLoadingSelector,
  pendingArtisanPrivateInquiryByIdSelector,
} from '../../../../modules/artisanModeration/privateProposals/Selectors';

import { InputField, TextArea, Upload } from '../../../../components/form';

import ModerationForm from '../../../../components/form/ModerationForm';
import getLangData from '../../../../utils/getLangData';

const ViewPrivateInquiry = (props) => {
  const {
    isLoading,
    pendingIsLoading,

    inquiryID,
    moderationId,
    inquiry,
    getProposals,
    updatePendingPrivateInquiry,
    moderatePendingProposal,
    getPrivateInquiries,
  } = props;
  const lang = getLangData().fields
  useEffect(() => {
    // getProposals(inquiryID);
    getProposals();
    console.log(inquiryID);
  }, [inquiryID, getProposals]);

  return (
    <Formik
      enableReinitialize
      initialValues={{ ...inquiry }}
      onSubmit={(values) => {
        moderatePendingProposal({
          proposalId: inquiryID,
        }, values.moderationType);
      }}
    >
      {({ values, handleSubmit }) => {
        return (
          <ModerationForm
            handleSubmit={handleSubmit}
            heading={lang.view_pending_private_inquiry}
            isLoading={isLoading || pendingIsLoading}
          >
            <InputField
              name="inquiry.customerBusinessName"
              label={lang.customer_name}
            />
            <InputField
              name="inquiry.artisanName"
              label={lang.artisan_name}
            />
            <InputField name="inquiry.aproductName" label={lang.product_name} />
            {/* <TextArea name='aproductId.description' label='Product Description' /> */}
            <TextArea name="message" label={lang.message} />
            <InputField name="inquiry.qtyRequired" label={lang.quantity_required} />
            <Upload
              data={{ userID: 'customerId' }}
              name="attachment"
              label={`${lang.inquiry_image} :`}
              S3Bucket="warshatna-users"
              // API="customer/customer-category-image-signedurl/"
              API="users/user-profile-image-signedurl"
            />
          </ModerationForm>
        );
      }}
    </Formik>
  );
};

const mapStateToProps = (state, props) => {
  const inquiryID = props.match.params.id;
  const moderationId = props.match.params.moderationId;
  return {
    inquiryID,
    moderationId,
    inquiry: pendingArtisanPrivateInquiryByIdSelector(state, inquiryID),
    isLoading: artisanPrivateInquiriesIsLoadingSelector(state),
    pendingIsLoading: pendingArtisansPrivateInquiryIsLoadingSelector(state),
  };
};

const mapDispatchToProps = {
  getProposals: getAllPendingProposalAction,
  moderatePendingProposal: moderatePendingProposalAction,
  rejectPendingProposal: rejectPendingProposalAction,
  // getPrivateInquiries: getPendingPrivateInquiriesAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(ViewPrivateInquiry);
